import { getRandomString, SetNonce } from '@services/utils/CarFaxLocalStorage';
import { CarfaxConnectUseCase } from '@components/dealsheet/shared/CarfaxConnect';

export const useCarfaxAuth = (): UseCarfaxAuthType => {
  const carFaxLogin = (clientId: string, callBackUrl: string): void => {
    const randomString = getRandomString(20);
    const randomStringBase64Encoded = btoa(randomString);
    SetNonce(randomStringBase64Encoded);
    // build the login url
    let url = `https://auth.carfax.com/authorize`;
    url += `?client_id=${clientId}`;
    url += `&redirect_uri=${callBackUrl}`;
    url += `&state=${randomStringBase64Encoded}`;
    url += `&response_type=code`;
    url += `&audience=https%3A%2F%2Fconnect.carfax.com`;
    url += `&scope=offline_access`;

    window.open(url, '_blank');
  };

  const dispatchLoginEvent = (carfaxConnectUseCase: CarfaxConnectUseCase = null): void => {
    let eventName = 'carfax-connect-login';

    if (carfaxConnectUseCase !== null) {
      eventName = `${eventName}-dealsheet-multi-use`;
    } else {
      // get the path
      const path = window.location.pathname;

      // update the event name based on the path
      if (path.startsWith('/dealsheet')) {
        eventName = `${eventName}-dealsheet`;
      }

      if (path.startsWith('/service')) {
        eventName = `${eventName}-single-use`;
      }
    }

    // create a login event
    const loginEvent = new Event(eventName);

    // dispatch the login event to the window (to handle logins from the dealsheet, to request the snapshotkey after login)
    window.dispatchEvent(loginEvent);
  };

  return { carFaxLogin, dispatchLoginEvent };
};

type UseCarfaxAuthType = {
  carFaxLogin: (clientId: string, callBackUrl: string) => void;
  dispatchLoginEvent: (carfaxConnectUseCase?: CarfaxConnectUseCase) => void;
};
